import { assertions } from './assertions';
import { fetchSendFirstMessageToAgent } from '../../../repositories/chats/v3/send-first-message-to-agent';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { getTelemetryKeyByPlatformAndHostType } from '../../../utils/getTelemetryKeyByPlatformAndHostType';
import { getGenericLikeError } from '../../../utils/logging/getGenericLikeError';
import { setFirstMessageFailed, setFirstMessagePending } from '../actions';
import { DEFAULT_ERROR_MESSAGE } from '../constants';
import { mappers } from '../mappers';
import { TFirstMessageResponse } from '../types';
import { getDomainBySource, getTelemetryBySource } from '../utils';

interface ISendFirstMessageAgentProps {
  /** Токен капчи(для проверки валидности, только desktop) **/
  captchaToken?: string;
  /** Идентификатор агента **/
  agentId: number;
  /** Текст сообщения **/
  text: string;
}

const SOURCE = 'agent';

/**
 * @description
 * Отправка первого сообщения агенту
 */
export const sendFirstMessageAgent =
  ({ agentId, text, captchaToken }: ISendFirstMessageAgentProps): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, telemetry, logger, custom: { realDevice, hostType } }) => {
    dispatch(setFirstMessagePending());

    const agentTelemetry = getTelemetryBySource(telemetry, SOURCE);

    const domain = getDomainBySource(SOURCE);

    const startTime = Date.now();

    try {
      const initTelemetryKey = getTelemetryKeyByPlatformAndHostType({
        eventKey: `${ETelemetryEvents.ChatFirstMessageSendInit}.${SOURCE}`,
        deviceType: realDevice,
        hostType,
      });

      telemetry.increment(initTelemetryKey);

      const response = (await fetchSendFirstMessageToAgent({
        httpApi,
        parameters: {
          userId: agentId,
          text,
          captchaToken,
        },
        mappers,
      })) as TFirstMessageResponse;

      assertions.forEach(assertion => {
        dispatch(
          assertion(response, {
            domain,
            telemetry: agentTelemetry,
            text,
            startTime,
          }),
        );
      });
    } catch (error) {
      agentTelemetry.increment(ETelemetryEvents.ChatFirstMessageSendUnknownError);

      const unknownError = getGenericLikeError({
        message: DEFAULT_ERROR_MESSAGE,
        domain,
        error,
      });

      logger.error(unknownError);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({}));
    }
  };
